"use client";

import { useState } from 'react';
import { Modal, Form, Input, Select, Button, notification, ConfigProvider } from 'antd';
import styles from './PriceModal.module.scss';
import { useLocale, useTranslations } from 'next-intl';
import { PRICE_DATA } from '../../constants';
import { PriceModalProps } from './types';

export const PriceModal = ({ form, isOpen, onClose }: PriceModalProps) => {
  const t = useTranslations('price');
  const locale = useLocale();   
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (values: { plan: string; name: string; email: string }) => {
    try{
      setLoading(true);
      await fetch('/api/sendAI', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          packet: values.plan,
          name: values.name,
          email: values.email,
          locale: locale,
        })
      });
    }catch(e){
      console.error(e);
    }finally{
      setLoading(false);
      notification.success({
        title: t('notification.title'),
        placement: 'topRight',
      });
      onClose();
      form.resetFields();
      
    }  
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            contentBg: 'var(--color-cream)',
            titleFontSize: 20
          },
        },
      }}
    >
      <Modal
        open={isOpen}
        onCancel={onClose}
        footer={null}
        title={t('modal.title')}
        centered
        className={styles.modal}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item name="plan" label={t('modal.plan')} rules={[{ required: true }]}>
            <Select options={PRICE_DATA.map((p) => ({ value: p.plan, label: t(`${p.plan}.name`) }))} />
          </Form.Item>
          <Form.Item name="name" label={t('modal.name')} rules={[{ required: true }]}>
            <Input placeholder={t('modal.namePlaceholder')} />
          </Form.Item>
          <Form.Item name="email" label={t('modal.email')} rules={[{ required: true, type: 'email' }]}>
            <Input placeholder={t('modal.emailPlaceholder')} />
          </Form.Item>
          <Form.Item className={styles.btnRow}>
            <Button className={styles.btnClose} onClick={onClose}>
              {t('modal.close')}
            </Button>
            <Button type="primary" htmlType="submit" className={styles.btnSubmit} loading={loading}>
              {t('modal.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </ConfigProvider>
  );
};
